(() => {
  const form = document.getElementById('ContactForm');
  const message = document.getElementById('ContactMessage');
  if (!form || !message) return;
  const params = new URLSearchParams(location.search);
  const mode = form.dataset.contactMode || '';
  const item = form.dataset.contactItem || '';
  const badge = form.dataset.contactBadge === 'true';
  const partNeedsCar = mode === 'part' && form.dataset.car === 'required';
  const topic = document.getElementById('ContactTopic');
  const car = document.getElementById('ContactCar');
  const destination = document.getElementById('ContactDestination');
  const vin = document.getElementById('ContactVin');
  const whichPart = document.getElementById('ContactPart');
  const badgeSizes = Array.from(form.querySelectorAll('.contact-field--badge input[type="radio"]'));
  const extra = (key, max) => (params.get(key) || '').trim().slice(0, max);
  if (car && !car.value.trim()) car.value = extra('car', 160);
  const showBadge = on => {
    if (on) form.dataset.contactBadge = 'true';
    else delete form.dataset.contactBadge;
    badgeSizes.forEach((input, index) => {
      input.disabled = !on;
      input.required = on && index === 0;
    });
  };
  showBadge(badge);
  if (mode === 'fit' && whichPart) {
    const emblemPicked = () => /emblem/i.test(whichPart.value);
    whichPart.addEventListener('change', () => showBadge(emblemPicked()));
    showBadge(emblemPicked());
  }
  const sizeHint = extra('dimensions', 240).match(/\b(74|82)\b/);
  if (badge && sizeHint && !badgeSizes.some(input => input.checked)) {
    const hinted = badgeSizes.find(input => input.value.startsWith(sizeHint[1]));
    if (hinted) hinted.checked = true;
  }
  if (topic && mode) {
    const pattern = mode === 'plate' ? /plate setup/i : mode === 'wheel' ? /steering wheel/i : mode === 'part' && !badge ? /parts and car care inquiry/i : /fit my car/i;
    let match = Array.from(topic.options).find(option => pattern.test(option.text));
    if (!match && mode === 'part' && !badge) {
      match = new Option('Parts and car care inquiry', 'Parts and car care inquiry');
      topic.add(match);
    }
    if (match) topic.value = match.value;
  }
  const updateFields = () => {
    const value = topic ? topic.value : '';
    const plateTopic = !mode && /plate setup/i.test(value);
    const needsCar = mode ? mode !== 'part' || partNeedsCar : /plate setup|steering wheel|fit my car/i.test(value);
    form.dataset.car = needsCar ? 'required' : 'optional';
    if (plateTopic) form.dataset.topic = 'plate';
    else delete form.dataset.topic;
    if (car) car.required = needsCar;
    if (destination) {
      destination.disabled = mode !== 'plate' && !plateTopic;
      destination.required = !destination.disabled;
    }
    if (vin) vin.disabled = mode !== 'wheel';
    if (whichPart) whichPart.disabled = mode !== 'fit';
    if (car) car.setCustomValidity('');
  };
  if (topic) topic.addEventListener('change', updateFields);
  updateFields();
  if (car) car.addEventListener('input', () => car.setCustomValidity(''));
  // Capture phase on window, so a missing year stops the send before Shopify's spam check (whose own submit listener
  // on the form ignores preventDefault) or any other listener sees it.
  window.addEventListener('submit', event => {
    if (event.target !== form) return;
    if (car && car.required && !/\b(?:19|20)\d{2}\b/.test(car.value)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      car.setCustomValidity('Include your car’s year, make and model, for example 2020 BMW 330i.');
      car.reportValidity();
    }
  }, true);
  if (!mode) return;
  const submit = form.querySelector('button[type="submit"]');
  if (submit) submit.textContent = mode === 'plate' ? 'Request availability' : mode === 'wheel' ? 'Request my quote' : mode === 'fit' ? 'Send fit check' : badge ? 'Check my fit' : 'Send item inquiry';
  if (message.value.trim()) return;
  const lines = mode === 'plate'
    ? ['I am interested in: ' + item + '.', '', 'Plate size: ', 'Intended display use: ', '', 'Please confirm availability for my location, vehicle fit, included parts, total price and delivery time.']
    : mode === 'wheel'
    ? ['Quote for: ' + item, 'LED shift display (yes/no): ', 'Carbon paddles (yes/no): ', 'Stitching color: ', 'Heated wheel now (yes/no): ', '', 'Please confirm fit, total price and build time.']
    : mode === 'fit'
    ? ['Please help me choose the right part for my car.' + (extra('looking', 80) ? ' I searched for: ' + extra('looking', 80) + '.' : '')]
    : badge
    ? ['I am interested in: ' + item + '.', '', 'Anything else we should know: ']
    : partNeedsCar
    ? ['I am interested in: ' + item + '.', '', 'Installation location: ' + extra('install', 120), 'Measurements or fit details: ' + extra('dimensions', 240), '', 'Please confirm fit, exact item, included parts, total price and delivery time for my car.']
    : ['I am interested in: ' + item + '.', '', 'Please confirm the exact item, total price and delivery time.'];
  message.value = lines.join('\n');
})();
